import React, { useState } from "react";
import "./OrderCard.css";
import { format, parseISO, differenceInMinutes, differenceInHours, differenceInDays, differenceInMonths } from "date-fns";

const OrderCard = ({ order }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    const formatDate = (dateString) => {
        const now = new Date();
        const parsedDate = parseISO(dateString);
        const minutesAgo = differenceInMinutes(now, parsedDate);
        const hoursAgo = differenceInHours(now, parsedDate);
        const daysAgo = differenceInDays(now, parsedDate);

        // Check if the date is from the current year
        const isCurrentYear = parsedDate.getFullYear() === now.getFullYear();

        if (minutesAgo < 1) {
            return "Just now";
        } else if (minutesAgo < 60) {
            return `${minutesAgo} minute${minutesAgo > 1 ? "s" : ""} ago`;
        } else if (hoursAgo < 24) {
            return `${hoursAgo} hour${hoursAgo > 1 ? "s" : ""} ago`;
        } else /*if (daysAgo < 30) {
            return `${daysAgo} day${daysAgo > 1 ? "s" : ""} ago`;
        } else*/ {
            // Format based on the year
            return format(parsedDate, isCurrentYear ? "dd MMM" : "dd MMM yyyy");
        }
    };

    return (
        <div className="order-card">
            <div style={{ marginBottom: '10px', fontSize: '12px' }} className="order-header">
                <p style={{ marginBottom: '0' }}>Order Id: {order.orderId}</p>
                <p style={{ marginBottom: '0' }}>{formatDate(order.date)}</p>
            </div>
            {order.items.map((item, index) => (
                <div key={index} className="order-item">
                    <img src={item.productImageUrl[0]} alt={item.name} className="order-image" />
                    <div>
                        <p style={{ marginBottom: '5px', fontWeight: 'bold', fontSize: '14px' }}>{item.productTitle}</p>
                        {
                            item.status &&
                            <p style={{ marginBottom: '5px' }}>Status: {<font style={{ fontSize: '14px', color: (item.status === "Cancelled" ? "red" : "green") }}>{item.status}</font>}</p>
                        }
                        {
                            item.description &&
                            <p style={{ fontSize: '14px', marginBottom: '5px' }}>{item.description}</p>
                        }
                        {
                            item.status !== "Delivered" &&
                            <a href={item.shippedByURL}> <button style={{ fontSize: '14px' }} className="track-order">Track Your Order</button></a>
                        }
                        {item.tracking &&
                            <p style={{ fontSize: '14px', marginBottom: '5px' }}>Tracking no: {item.tracking}</p>
                        }
                    </div>
                </div>
            ))
            }

            {
                isExpanded && (
                    <div className="collapsible-content">
                        <div style={{ paddingBottom: '10px' }} className="order-contact border-bottom">
                            <p style={{ marginBottom: '0' }}>How can we help you?</p>
                            <button className="contact-us">CONTACT US</button>
                        </div>
                        <div className="order-details border-bottom">
                            <h6>Shipping Details</h6>
                            <p style={{ marginBottom: '5px', fontSize: '14px' }}>{order.shippingDetails.name}</p>
                            <p style={{ marginBottom: '5px', fontSize: '14px' }}>{order.shippingDetails.address}</p>
                            <p style={{ marginBottom: '5px', fontSize: '14px' }}>{order.shippingDetails.userPhoneNumber}</p>
                        </div>
                        <div className="order-summary" style={{ fontFamily: 'Arial, sans-serif', padding: '10px' }}>
                            <h4 style={{ fontSize: '16px', fontWeight: '500', marginBottom: '10px' }}>Order Summary</h4>

                            <p style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', color: '#6b7280', marginBottom: '6px' }}>
                                <span>MRP:</span>
                                <span style={{ color: '#1f2937' }}>₹{order.orderSummary.cartTotal}</span>
                            </p>

                            <p style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', color: '#6b7280', marginBottom: '6px' }}>
                                <span>Applied Discount:</span>
                                <span style={{ color: '#1f2937' }}>₹{order.orderSummary.discount}</span>
                            </p>

                            <p style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', color: '#6b7280', marginBottom: '6px' }}>
                                <span>Unit Price:</span>
                                <span style={{ color: '#1f2937' }}>{decodeURI(order.orderSummary.unitPriceTotal)}</span>
                            </p>

                            <p style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', color: '#6b7280', marginBottom: '6px' }}>
                                <span>GST Amount:</span>
                                <span style={{ color: '#1f2937' }}>{decodeURI(order.orderSummary.productGstTotal)}</span>
                            </p>

                            <p style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', color: '#6b7280', marginBottom: '6px' }}>
                                <span>Subtotal:</span>
                                <span style={{ color: '#1f2937' }}>₹{order.orderSummary.subtotal}</span>
                            </p>

                            <p style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', color: '#6b7280', marginBottom: '6px' }}>
                                <span>Delivery Charges:</span>
                                <span style={{ color: '#1f2937' }}>₹{order.orderSummary.deliveryCharges}</span>
                            </p>

                            <p style={{ display: 'flex', justifyContent: 'space-between', fontSize: '16px', fontWeight: 'bold', color: '#10b981', marginTop: '10px' }}>
                                <span>Amount Paid:</span>
                                <span>₹{order.orderSummary.amountPaid}</span>
                            </p>
                        </div>

                    </div>
                )
            }

            <div style={{ marginBottom: '5px' }} className="expand-collapse text-center row" onClick={toggleExpand}>
                <span style={{ fontSize: '12px', color: 'green' }}>{!isExpanded ? "View Detail & Contact Us" : "Close"}</span>
                <span className="icon">{<img style={{ width: '20px', transform: (isExpanded ? "rotate(180deg)" : "rotate(0deg)") }} src="https://appcdn.goqii.com/storeimg/95154_1733406740.webp" />}</span>
            </div>
        </div >
    );
};

export default OrderCard;
